/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ send: NonNullable<unknown> }} Notice_Send_PausedInputs */

const en_notice_send_paused = /** @type {(inputs: Notice_Send_PausedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.send}” was paused automatically to protect delivery. Review and resume`)
};

/**
* | output |
* | --- |
* | "“{send}” was paused automatically to protect delivery. Review and resume" |
*
* @param {Notice_Send_PausedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notice_send_paused = /** @type {((inputs: Notice_Send_PausedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notice_Send_PausedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notice_send_paused(inputs)
});